import React, { MouseEvent } from 'react'
import Link from 'next/link'
// import * as gtag from '@/lib/gtag'

type ButtonLinkTYPE = {
  text: string
  link: string
  classname?: string
}

const ButtonLink = ({ text, link, classname }: ButtonLinkTYPE) => {
  // const handleSubmit = (
  //   event: React.MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
  // ): void => {
  //   event.preventDefault()
  //   const url = event.currentTarget.href

  //   if (link === '/news/') {
  //     gtag.event({
  //       url: url,
  //       action: 'click',
  //       category: 'button',
  //       label: 'spot,notice',
  //     })

  //     return
  //   }
  // }
  return (
    <div className="text-center">
      <Link href={link}>
        <a
          className={`c-button_link mx-auto mt-4 block text-sm ${classname}`}
          // onClick={(event) => handleSubmit(event)}
        >
          {text}
        </a>
      </Link>
    </div>
  )
}

export default ButtonLink
